export default __webpack_public_path__ + "static/media/alert-icon.d054e230.svg";